import type { AiRouter } from "replo-publisher/src/trpc/routers/ai";

import { createTrpcRouterConfig } from "@v2/trpc/config";
import { getNamespacedQueryClient } from "@v2/trpc/trpc";

const {
  router: aiRouter,
  client: aiClient,
  utils: aiUtils,
  options: aiOptions,
} = createTrpcRouterConfig<AiRouter>({
  path: "ai",
  queryClient: getNamespacedQueryClient("ai"),
});

export { aiClient, aiRouter, aiUtils, aiOptions };
